module.exports = __webpack_public_path__ + "static/media/logo-fff-lfa.77fe4d7a.png";